// Angular
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Pages
import { CoreModule } from '../../core/core.module';
// Partials
import { PartialsModule } from '../partials/partials.module';
import { AdminSettingsModule } from './admin-settings/admin-settings.module';
import { ShipmentsModule } from './shipments/shipments.module';
import { UserInterfaceModule } from './user-interface/user-interface.module';
import { UsrMngtModule } from './usr-mngt/usr-mngt.module';
@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    CoreModule,
    PartialsModule,
    UsrMngtModule,
    ShipmentsModule,
    UserInterfaceModule,
    AdminSettingsModule,
  ],
  providers: [],
})
export class PagesModule {}
